module.exports = __webpack_public_path__ + "res/Roboto-MediumItalic-webfont.svg?ed09d7df107eb64f28fce825144009e3";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-MediumItalic-webfont.svg
// module id = 85
// module chunks = 0